/** Shared cache-bust token. Bump when shipping CSS/JS/static asset changes. */
export const ASSET_VERSION = "20261007m";

const LIVE_KEY = "ccj_live_asset_v";

let liveVersion = null;
try {
  liveVersion = sessionStorage.getItem(LIVE_KEY) || null;
} catch (_) {
  liveVersion = null;
}

/** Build-time version, or Admin Shell publish version when primed. */
export function getAssetVersion() {
  return liveVersion || ASSET_VERSION;
}

export function setLiveAssetVersion(version) {
  const next = String(version || "").trim();
  if (!next) return;
  liveVersion = next;
  try {
    sessionStorage.setItem(LIVE_KEY, next);
  } catch (_) {}
}

/** Read Firestore site_config/cache (public). Safe to call on every app page. */
export async function primeLiveAssetVersion() {
  try {
    const { db, isConfigured } = await import("./firebase-config.js?v=20261007m");
    if (!isConfigured || !db) return getAssetVersion();
    const { doc, getDoc } = await import(
      "https://www.gstatic.com/firebasejs/10.12.2/firebase-firestore.js"
    );
    const snap = await getDoc(doc(db, "site_config", "cache"));
    const ver = snap.exists() ? snap.data()?.asset_version : null;
    if (ver) setLiveAssetVersion(ver);
  } catch (err) {
    console.warn("[CookieCodeJar] live asset version:", err?.message || err);
  }
  return getAssetVersion();
}

/** Append or replace ?v= for cache busting (works for relative + https URLs). */
export function withAssetVersion(url) {
  const raw = String(url || "").trim();
  if (!raw || /^(data:|blob:)/i.test(raw)) return raw;
  const version = getAssetVersion();
  if (/^https?:\/\//i.test(raw)) {
    try {
      const u = new URL(raw);
      u.searchParams.set("v", version);
      return u.toString();
    } catch (_) {
      /* fall through */
    }
  }
  const stripped = raw.replace(/([?&])v=[^&]*/g, "$1").replace(/[?&]$/, "").replace(/\?&/, "?");
  const sep = stripped.includes("?") ? "&" : "?";
  return `${stripped}${sep}v=${version}`;
}

/** Jar frame URL (WebP). */
export function jarImageSrc(key) {
  return withAssetVersion(`jar/jar_${key}.webp`);
}

/** Membership avatar cookie frame (dough / batch / master -> tier_1/2/3). */
export function tierFrameSrc(tierId) {
  const map = { dough: "1", batch: "2", master: "3" };
  const n = map[tierId];
  if (!n) return null;
  return withAssetVersion(`jar/tier_${n}.webp`);
}

/** Twinkle sparkle overlay for paid avatar frames. */
export function sparkSrc() {
  return withAssetVersion(`jar/spark.webp`);
}
